<template>
  <div>
    <div class="box">
      <div>服务准备流程追踪</div>
      <el-row style="margin-top:100px">
        <order-state :type="type" :activeNumber="activeNumber"></order-state>
      </el-row>
      <el-row class="btnclick">
        <el-tooltip class="item" effect="dark" content="点击管理应用直接进入后台" placement="bottom">
          <el-button :disabled="!appId" @click="handReadApp">管理应用</el-button>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="应用准备就绪后即可点击访问" placement="bottom">
          <el-button
            :disabled="!domain"
            @click="handleDomain"
            :style="{
              background: domain ? '#005EBA' : 'rgb(0, 94, 186,0.7)',
              color: '#fff',
              fontWeight: 300
            }"
          >访问应用</el-button>
        </el-tooltip>
      </el-row>
    </div>
  </div>
</template>
<script>
import OrderState from '@/components/OrderState';
export default {
  name: 'StatusOrder',
  components: { OrderState },
  data() {
    return {
      type: 'orderState',
      activeNumber: 0,
      appId: '',
      domain: null,
      statusMap: {
        confirmed: 0,
        reviewed: 1,
        delivered: 1,
        ready: 2
      }
    };
  },
  mounted() {
    const _th = this;
    this.timer = setInterval(function() {
      _th.getMyOrderInfoState();
      if (_th.activeNumber >= 3) {
        clearInterval(_th.timer);
      }
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  created() {
    this.orderID = this.$route.params.orderID;
    this.getOrderInfo();
    this.getMyOrderInfoState();
  },
  methods: {
    handReadApp() {
      this.$router.push({
        name: 'enterpriseAppDetails',
        params: {
          appId: this.appId
        }
      });
    },
    handleDomain() {
      window.open(this.domain, '_blank');
    },
    getOrderInfo() {
      this.$store
        .dispatch('GetMyOrderInfo', {
          orderID: this.orderID
        })
        .then(res => {
          if (res) {
            this.order = res;
          }
        });
    },
    getMyOrderInfoState() {
      this.Loading = true;
      this.$store
        .dispatch('GetMyOrderInfoState', {
          orderID: this.orderID
        })
        .then(res => {
          this.Loading = false;
          if (res) {
            this.appId = res.deliveryAppID;
            if (res.domains && res.domains.length > 0) {
              this.domain = res.domains[0];
            }
            this.formatStepStatus(res.status);
          }
        })
        .catch(() => {
          this.Loading = false;
        });
    },
    formatStepStatus(status) {
      this.activeNumber = this.statusMap[status] || 0;
    },
    getDeliveryAppStatus() {
      this.$store
        .dispatch('GetDeliveryAppDomain', {
          eid: this.eid,
          orderID: this.orderID
        })
        .then(res => {
          if (res.data) {
            const domains = res.data.domains;
            if (domains.length > 0) {
              if (domains[0].certificate_id != undefined) {
                this.domain = 'https://' + domains[0].domain_name;
              } else {
                this.domain = 'http://' + domains[0].domain_name;
              }
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.elmlc {
  padding-top: 70px;
}
.box {
  margin-top: 51px;
  padding: 16px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid rgba(84, 88, 90, 0.2);
}
.btnclick {
  display: flex;
  justify-content: center;
  margin-top: 70px;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/payStatus/index.vue